import { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import type { ReactNode } from 'react';

interface Toast {
  tekst: string;
  fout: boolean;
}

const ToastContext = createContext<((tekst: string, fout?: boolean) => void) | null>(null);

const ZICHTBAAR_MS = 3000;

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toast, setToast] = useState<Toast | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const toon = useCallback((tekst: string, fout = false) => {
    setToast({ tekst, fout });
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => setToast(null), ZICHTBAAR_MS);
  }, []);

  useEffect(() => () => void (timer.current && clearTimeout(timer.current)), []);

  return (
    <ToastContext.Provider value={toon}>
      {children}
      {toast && (
        // aria-live, zodat een schermlezer de melding ook meekrijgt.
        <div className={`vs-toast${toast.fout ? ' vs-toast--fout' : ''}`} role="status" aria-live="polite">
          {toast.tekst}
        </div>
      )}
    </ToastContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within a ToastProvider');
  return ctx;
}
